import { FunctionComponent, useMemo } from 'react';
import { AnchorButton } from '../../../../components/index';
import { Heading } from 'evergreen-ui';
import { Environment } from 'services/Environment';

type UsersSectionProps = {
    authenticated: boolean;
};

export const UsersSection: FunctionComponent<UsersSectionProps> = ({ authenticated }) => {
    const showLoginOrLogoutButton = useMemo(() => {
        if (authenticated) {
            return (
                <li>
                    <AnchorButton onClick={() => (window.location.href = '/logout')}>
                        Log out
                    </AnchorButton>
                </li>
            );
        }
        return (
            <li>
                <AnchorButton
                    onClick={() => {
                        window.location.href = `${Environment.MARKETPLACE_URL}/login?redirect=${encodeURIComponent(window.location.href)}`;
                    }}
                >
                    Log in Or Sign Up
                </AnchorButton>
            </li>
        );
    }, [authenticated]);

    return (
        <>
            <Heading>For Users</Heading>
            <ul>{showLoginOrLogoutButton}</ul>
        </>
    );
};
